import Rollbar from 'rollbar';
import store from '../store';

export const rollbarConfig = {
  accessToken: process.env.REACT_APP_ROLLBAR_ACCESS_TOKEN,
  environment: process.env.REACT_APP_ENV,
  autoInstrument: true,
  scrubFields: ["pw", "pass", "passwd", "password", "secret", "confirm_password", "confirmPassword", "password_confirmation", "passwordConfirmation", "access_token", "accessToken", "secret_key", "secretKey", "secretToken"],
  overwriteScrubFields: true
}

export const rollbarInstance = new Rollbar(rollbarConfig);

export const sendRollbarError = (error, data = {}) => {
  const subscription = store.getState().subscription;

  if(subscription.email) {
    data.name = subscription.name;
    data.email = subscription.email;
  }

  if(process.env.REACT_APP_ENV === 'production'){
    rollbarInstance.error(error, data);
  }
  else {
    console.log(`Rollbar.error: ${error}`, data);
  }
}

export default sendRollbarError;
